<template>
    <VForm
        v-slot="{ form }"
        :on-submit-async="submit"
        @success="(value)=>this.$emit('success',value)">
        <ApplicableCashbackProgramCreateAndUpdateFormItems
            :form="form"
            :data="applicableCashbackProgram" />
    </VForm>
</template>
<script>
import { rootActions, Getters } from '@/store/types'
import VForm from '@/components/VForm.vue'
import ApplicableCashbackProgramCreateAndUpdateFormItems from '@/components/ApplicableCashbackProgramCreateAndUpdateFormItems.vue'

export default {
    components: {
        VForm,
        ApplicableCashbackProgramCreateAndUpdateFormItems,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
    },
    computed: {
        applicableCashbackProgram () {
            return this.$store.getters[Getters.cashback.GET_APPLICABLE_CASHBACK_PROGRAM](this.id)
        },
    },
    methods: {
        async submit (values) {
            const res = await this.$store.dispatch(
                rootActions.UPDATE_APPLICABLE_CASHBACK_PROGRAM, { id: this.id, ...values },
            )
            return res
        },
    },
}
</script>
